import axios from "../config/axios"

// Mail connectors of registry projects: the SMTP mailbox a project sends from (MailConnectorDTO) and its saved
// HTML templates (MailTemplateDTO). The password is never returned, only passwordSet.
export const MailConnectorRepository = {
  getByProject: (projectId) => axios.get(`/api/connector/mail/project/${projectId}`),
  get: (id) => axios.get(`/api/connector/mail/${id}`),
  // body: CreationMailConnectorDTO (projectId required)
  create: (body) => axios.post(`/api/connector/mail`, body),
  // empty password keeps the stored one; removePassword: true clears it
  edit: (id, body) => axios.put(`/api/connector/mail/${id}`, body),
  delete: (id) => axios.delete(`/api/connector/mail/${id}`),

  // {connected, connectorId, connectorName, fromAddress, fromName}; not connected = the default mail account
  getStatus: (projectId) => axios.get(`/api/connector/mail/project/${projectId}/status`),
  // sends through the project's connector, or the default mail account when it has none. body: SendConnectorMailDTO
  send: (projectId, body) => axios.post(`/api/connector/mail/project/${projectId}/send`, body),

  getDefaultTemplate: () => axios.get(`/api/connector/mail/template/default`),
  // "default" falls back to the built-in template
  getTemplate: (projectId, name) => axios.get(`/api/connector/mail/project/${projectId}/template/${encodeURIComponent(name)}`),
  saveTemplate: (projectId, name, html) =>
    axios.put(`/api/connector/mail/project/${projectId}/template/${encodeURIComponent(name)}`, {html}),
  deleteTemplate: (projectId, name) =>
    axios.delete(`/api/connector/mail/project/${projectId}/template/${encodeURIComponent(name)}`),
}
